export default __webpack_public_path__ + "static/media/inwardView.acae55e2.png";